import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("kf_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

// Turn `/api/files/...` relative URL into an absolute one for <img src>
export const asAbsolute = (url) => {
    if (!url) return "";
    if (url.startsWith("http://") || url.startsWith("https://")) return url;
    if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
    return url;
};
